import React from 'react';

import vk from '../../Resources/Icons/VK Logo 2.svg';
import telegramm from '../../Resources/Icons/telegram.svg';
import mail from '../../Resources/Icons/email.svg';
import tel from '../../Resources/Icons/phone.svg';
import habr from '../../Resources/Icons/habr.svg';

import resume from '../../Resources/Files/titov.pdf';
import { Link } from 'react-router-dom';
import { randPhoto } from '../../Utils/Photo';


export default function Main() {
  return (
    <section className='main'>
      
      <div className='cards-container-grid'>
        <div className='card card-images-social'>
          <img src={randPhoto()} className='card__image' alt='Фотография' />
          <div className='card__social-container'>
            <a
              href='mailto:N3kto.1@yandex.ru?body=У твоего любимого заказчика появился вопрос'
              target='_blank'
              rel='noreferrer'
            >
              <img src={mail} className='card__social-link' alt='Иконка социальной сети'/>
            </a>
            <a href='https://t.me/TitovAV' target='_blank' rel='noreferrer'>
              <img src={telegramm} className='card__social-link' alt='Иконка социальной сети'/>
            </a>
            <a href='https://vk.com/idtens91' target='_blank' rel='noreferrer'>
              <img src={vk} className='card__social-link' alt='Иконка социальной сети'/>
            </a>
            <a
              href='https://career.habr.com/titovav12'
              target='_blank'
              rel='noreferrer'
            >
              <img src={habr} className='card__social-link' alt='Иконка социальной сети'/>
            </a>
            <a href='Tel:89101636692' target='_blank' rel='noreferrer'>
              <img src={tel} className='card__social-link' alt='Иконка социальной сети'/>
            </a>
          </div>
        </div>
        <div className='card'>
          <h2 className='card__title'>О себе</h2>
          <p className='card__text'>
            Разработчик и руководитель проектов с 6 летним стажем в продуктовой
            компании. Планирую развиваться и растить
            компетенции&nbsp;в&nbsp;сфере IT!
          </p>
          <p className='card__text card__text-bold'>Мой стек:</p>
          <ul className='card__text-ul'>
            <li className='card__text-li'>
              Уверенно - JS (CSS, HTML), ReactJS, NodeJS, MobX, SQL(PostgreSQL,
              MS SQL), Git, Nginx, IIS, SonarQube
            </li>
            <li className='card__text-li'>
              Средне - Jenkins, Kubernetes, Docker
            </li>
            <li className='card__text-li'>
              Работал по мануалам - C#, Java, PHP, MongoDB
            </li>
          </ul>
          <Link to='/myWay' className='card__link card__link-color'>
            Мой путь
          </Link>
        </div>
        <div className='card'>
          <h2 className='card__title'>Мои проекты</h2>
          <p className='card__text'>
            Люблю создавать и быть полезным для команды! В свободное время занимаюсь личными проектами. В моей копилке множество мелких и
            крупных проектов.
          </p>
          <p className='card__text card__text-bold'>Самые любимые:</p>
          <ul className='card__text-ul'>
            <li className='card__text-li'>
              Дневник тренировок для тренеров и спортсменов -
              WHS
            </li>
            <li className='card__text-li'>Игра для Android - Alien TTT</li>
            <li className='card__text-li'>Сайты для бизнеса</li>
          </ul>
          <Link to='/developments' className='card__link card__link-color'>
            Мои разработки
          </Link>
        </div>
        {/* <div className='card'>
          <h2 className='card__title'>Мои возможности</h2>
          <p className='card__text'>
            Готов сотрудничать по различным направлениям:
          </p>
          <ul className='card__text-ul'>
          <li className='card__text-li'>Инфобез и анализ приложения на уязвимости</li>
            <li className='card__text-li'>Разработка сайтов и информационных систем</li>
            <li className='card__text-li'>Аудит информационных систем</li>
            <li className='card__text-li'>
              Подготовка технической документации
            </li>
            <li className='card__text-li'>
              Подготовка и оформление документов на регистрацию
              ПО&nbsp;в&nbsp;Роспатент и Реестр отечественного ПО
            </li>
          </ul>
          <Link to='/services' className='card__link card__link-color'>
            Услуги
          </Link>
        </div> */}
         <div className='card'>
          <h2 className='card__title'>Готов сотрудничать по различным направлениям</h2>
          <ul className='card__text-ul'>
          <li className='card__text-li'>Инфобез и анализ приложения на уязвимости</li>
            <li className='card__text-li'>Разработка сайтов и информационных систем</li>
            <li className='card__text-li'>
              Подготовка технической документации
            </li>
            <li className='card__text-li'>
              Подготовка и оформление документов на регистрацию
              ПО&nbsp;в&nbsp;Роспатент и Реестр отечественного ПО
            </li>
          </ul>
          <a
            href={resume}
            target='_blank'
            className='card__link'
            rel='noreferrer'
          >
            Мое резюме
          </a>
        </div>
      </div>
      <div className='card-horizontal'>
        <p className='card__text'>
          Я профессиональный разработчик с большим опытом работы в разных
          сферах, всегда выполняю порученную работу качественно и в срок.
          Буду&nbsp;рад помочь вам с проектами и улучшить сервисы.
          Жду&nbsp;предложений и готов обсудить условия сотрудничества.
        </p>
      </div>
    </section>
  );
}
